import type { Delivery } from '@citibox-panel/api-client';
import {
  deliveryClipboardHeaders,
  deliveryClipboardValues,
  type ClipboardRecipient,
} from './deliveryClipboardCells';

const TAB = '\t';
const LF = '\n';

// The plain (text/plain) clipboard flavour for one delivery row: two tab-separated lines
// (headers, then values) joined by a single LF with no trailing newline. It is the fallback
// flavour — for spreadsheet/terminal targets, and for browsers without ClipboardItem; rich-text
// targets (Notion, Zendesk, Docs) rebuild the table from the sibling text/html flavour
// (buildDeliveryClipboardHtml). Values come from the shared deliveryClipboardValues, so the two
// flavours cannot drift.
export function buildDeliveryClipboardText(
  delivery: Delivery,
  phone: string,
  recipient?: ClipboardRecipient,
): string {
  return [
    deliveryClipboardHeaders(recipient).join(TAB),
    deliveryClipboardValues(delivery, phone, recipient).join(TAB),
  ].join(LF);
}
